exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-answer .modal-header {\n  border-bottom: 0;\n  margin-bottom: 32px; }\n\n.modal-answer .answer-list {\n  padding: 0 16px; }\n  .modal-answer .answer-list .answer-item {\n    margin-bottom: 16px;\n    line-height: 24px; }\n    .modal-answer .answer-list .answer-item:not(:last-child) {\n      border-bottom: 1px solid #d8d8d8; }\n    .modal-answer .answer-list .answer-item span {\n      display: block;\n      color: #3F4361;\n      text-transform: uppercase;\n      font-size: 12px;\n      opacity: .4; }\n    .modal-answer .answer-list .answer-item b {\n      display: block;\n      color: #004272;\n      font-weight: 500;\n      font-size: 18px;\n      padding-top: 4px;\n      padding-bottom: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Profile/components/Answers/styles.scss
// module id = 1396
// module chunks = 0